import { FilterWithConditionsInterface } from 'modules/contacts/hooks/use-filter-with-conditions';
import { getConditions } from 'modules/contacts/utils/get-conditions';
import { useCallback, useMemo } from 'react';
import { useFilterWithAbort } from 'shared/hooks/use-filter-with-abort';
import { LimitType } from 'shared/types/pagination-interface';
import { deepCompare } from 'shared/utils/deepCompare';
interface ApplyFilterWithConditionsInterface extends Pick<FilterWithConditionsInterface, 'conditions' | 'filter' | 'setConditions' | 'filtersReady' | 'filterFields'> {
  setLimit: React.Dispatch<React.SetStateAction<LimitType>>;
  abort: () => void;
  delay?: number;
  onFilterChange: () => void;
}
export const useApplyFilterWithConditions = ({
  filtersReady,
  filterFields,
  filter,
  conditions,
  setConditions,
  setLimit,
  abort,
  delay,
  onFilterChange
}: ApplyFilterWithConditionsInterface) => {
  const handleFilter = useCallback(() => {
    setConditions(getConditions({
      filter,
      filterFields
    }));
    onFilterChange();
    setLimit(10);
  }, [filter, filterFields, setConditions, setLimit]);
  const shouldUpdate = useMemo(() => filtersReady && !deepCompare(getConditions({
    filter,
    filterFields
  }), conditions), [conditions, filter, filterFields, filtersReady]);
  useFilterWithAbort({
    shouldUpdate,
    handleFilter,
    onAbort: abort,
    delay
  });
};